/*
 * product.js — PDP-Interaktivität (WP 2.3). IIFE-guarded, defer geladen INNERHALB der Section.
 * Nutzt die vorhandenen Foundations: window.Homedia.cart (.add/.open) — KEIN eigener Cart-Code.
 *
 * Verantwortlich für:
 *  - Varianten-Auswahl (Preis/Stock/URL/Add-Button/Buy-Now-Toggle) aus dem product-JSON im DOM
 *  - Galerie: Thumb-Rail (Desktop) + Swipe-Snap-Dots (Mobile)
 *  - Mengen-Stepper + Live-Gesamtsumme (Variante + angehakte Extras)
 *  - Compat-Verdikt (role=status) aus den ecosystem-Daten am <option>
 *  - Extras/Add-ons: bei Submit eigene Line-Items (items[]) mit _addon_for-Property
 *  - Sticky-Add-to-Cart: Desktop via IntersectionObserver, Mobile permanent (CSS)
 *  - „Häufig zusammen gekauft": Product-Recommendations-API (async)
 *
 * Progressive Enhancement: ohne JS bleibt das product-form ein echter POST /cart/add,
 * Galerie zeigt das erste Medium, Q-Block/Specs sind ohne JS lesbar.
 */
(function () {
  'use strict';
  if (window.HomediaPDP) return;
  window.HomediaPDP = true;

  var root = document.querySelector('[data-pdp]');
  if (!root) return;

  // ---------- product-Daten ----------
  var data = null;
  try {
    var dataEl = root.querySelector('[data-pdp-data]');
    if (dataEl) data = JSON.parse(dataEl.textContent);
  } catch (e) { data = null; }

  var form = root.querySelector('[data-pdp-form]');
  var idInput = root.querySelector('[data-variant-id]');
  var addBtn = root.querySelector('[data-add-btn]');
  var addLabel = root.querySelector('[data-add-label]');
  var addTotal = root.querySelector('[data-add-total]');
  var buyBtn = root.querySelector('[data-buy-now]');
  var stockEl = root.querySelector('[data-buy-stock]');
  var priceEl = root.querySelector('[data-buy-price]');
  var qtyInput = root.querySelector('[data-qty-input]');
  var stickyPrice = root.querySelector('[data-sticky-price]');
  var stickyTotal = root.querySelector('[data-sticky-total]');
  var selectMedia = null; // von initGallery gesetzt: schaltet die Galerie auf eine Medien-ID

  var money = (window.Homedia && window.Homedia.cart && window.Homedia.cart.formatMoney)
    ? window.Homedia.cart.formatMoney
    : function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };

  var strings = (window.theme && window.theme.strings) || {};
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  // =========================================================================
  // VARIANTEN
  // =========================================================================
  function selectedOptions() {
    var inputs = root.querySelectorAll('[data-option-input]:checked');
    var opts = [];
    inputs.forEach(function (inp) {
      var pos = parseInt(inp.getAttribute('data-option-input'), 10) - 1;
      opts[pos] = inp.value;
    });
    return opts;
  }

  function findVariant(opts) {
    if (!data || !data.variants) return null;
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      var match = true;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] != null && v.options[j] !== opts[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function variantById(id) {
    if (!data || !data.variants || id == null) return null;
    id = String(id);
    for (var i = 0; i < data.variants.length; i++) {
      if (String(data.variants[i].id) === id) return data.variants[i];
    }
    return null;
  }

  // Aktuelle Variante = die per Server vorausgewählte, nicht blind die erste. Reihenfolge:
  // (1) Treffer aus den angehakten Optionen, (2) die vom Server gerenderte hidden-ID
  // (selected_or_first_available_variant), (3) erste Variante. So bleiben AJAX-ID, hidden-Input
  // und Galerie schon vor der ersten Interaktion konsistent.
  var currentVariant = null;
  if (data && data.variants && data.variants.length) {
    currentVariant = findVariant(selectedOptions())
      || (idInput && variantById(idInput.value))
      || data.variants[0];
  }

  function updateOptionLabels() {
    root.querySelectorAll('[data-option-input]:checked').forEach(function (inp) {
      var pos = inp.getAttribute('data-option-input');
      var label = root.querySelector('[data-option-current="' + pos + '"]');
      if (label) label.textContent = inp.value;
    });
  }

  function onVariantChange() {
    var opts = selectedOptions();
    var v = findVariant(opts);
    updateOptionLabels();
    if (!v) {
      // Kombination existiert nicht → Add deaktivieren
      if (addBtn) { addBtn.disabled = true; }
      if (addLabel) addLabel.textContent = strings.unavailable || 'Nicht verfügbar';
      return;
    }
    currentVariant = v;
    if (idInput) idInput.value = v.id;

    // Galerie auf das Bild der gewählten Variante umschalten (typisches Shop-Verhalten).
    if (v.featured_media != null && selectMedia) selectMedia(v.featured_media);

    // Buy-Box-Preis live aktualisieren (Verkaufspreis + UVP-Streichpreis)
    updateBuyPrice(v);
    refreshTotals();

    // Varianten-Chip im H1 (Name · Modell · Variante) mitziehen
    var vChip = root.querySelector('[data-buy-variant-chip]');
    if (vChip) {
      if (v && v.title && v.title !== 'Default Title') {
        vChip.textContent = '· ' + v.title;
        vChip.hidden = false;
      } else {
        vChip.textContent = '';
        vChip.hidden = true;
      }
    }

    // Stock + Button
    if (addBtn) addBtn.disabled = !v.available;
    if (addLabel) addLabel.textContent = v.available ? (strings.addToCart || 'In den Warenkorb') : (strings.soldOut || 'Ausverkauft');
    if (stockEl) {
      stockEl.classList.toggle('is-out', !v.available);
    }

    // URL aktualisieren (ohne Reload)
    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
    }

    // Buy-Now reagiert auf Verfügbarkeit
    toggleBuyNow();

    // Der Bestand hängt an der VARIANTE (z. B. Silber 7 Stück, Schwarz 3). Nach dem Wechsel die
    // Menge neu deckeln — über ein change-Event, damit derselbe Clamp-Pfad (setQty) läuft.
    if (qtyInput) qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    else applyStockLimit();

    document.dispatchEvent(new CustomEvent('pdp:variant', { detail: { variant: v } }));
  }

  // =========================================================================
  // EXTRAS / ADD-ONS
  // =========================================================================
  function checkedAddons() {
    var out = [];
    root.querySelectorAll('[data-addon-input]:checked').forEach(function (cb) {
      out.push({
        id: cb.getAttribute('data-addon-variant'),
        price: parseInt(cb.getAttribute('data-addon-price'), 10) || 0
      });
    });
    return out;
  }

  // „Sofort kaufen" nimmt die angehakten Extras MIT in den Add (items[]) und springt direkt
  // zum Checkout; nur bei nicht verfügbarer Variante deaktiviert.
  function toggleBuyNow() {
    if (!buyBtn) return;
    buyBtn.disabled = !currentVariant || !currentVariant.available;
  }

  // =========================================================================
  // SUMME
  // =========================================================================
  function getQty() {
    var q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return isNaN(q) || q < 1 ? 1 : q;
  }

  // =========================================================================
  // BESTANDS-LIMIT
  // =========================================================================
  // Shopify begrenzt serverseitig: POST /cart/add.js antwortet bei zu großer Menge mit 422 — und
  // legt die verfügbare TEILMENGE trotzdem in den Warenkorb (live verifiziert: 8 von 3 verfügbaren
  // → 422, Warenkorb enthält danach 3). Der Client-Cap hier ist die Vorabprüfung, damit der Nutzer
  // gar nicht erst eine unmögliche Menge einstellen kann. Die Wahrheit bleibt der Server —
  // deshalb ist der sichtbare Fehler-Hinweis in cart.js Pflicht, nicht Kür (Race Conditions:
  // zweiter Tab, Bestandsänderung zwischen Seitenaufruf und Klick).
  var UNLIMITED = Infinity;

  // Ab wann der Hinweis „Nur noch X verfügbar" erscheint. Bei gut gefülltem Lager ist die Zahl
  // uninteressant (und wirkt wie künstliche Verknappung) — erst ab 4 oder weniger ist sie eine
  // echte Information. Die BEGRENZUNG selbst greift unabhängig davon immer.
  // Bewusst gegen maxAddable geprüft, nicht gegen den reinen Bestand: Wenn von 20 Stück schon 18
  // im Warenkorb liegen, stoppt der „+"-Button bei 2 — dann MUSS dort auch stehen, warum.
  var LOW_STOCK_HINT_BELOW = 5;

  function variantStock(v) {
    if (!v) return UNLIMITED;
    if (!v.inventory_management) return UNLIMITED;          // Bestand wird nicht verfolgt
    if (v.inventory_policy === 'continue') return UNLIMITED; // Überverkauf ausdrücklich erlaubt
    var q = parseInt(v.inventory_quantity, 10);
    if (isNaN(q)) return UNLIMITED;                          // Feld fehlt → nicht raten, nicht sperren
    return Math.max(0, q);                                   // negativ (Überverkauf in der Vergangenheit) → 0
  }

  // Wie viele Stück derselben Variante liegen bereits im Warenkorb? Die zählen gegen den Bestand.
  function qtyInCart(variantId) {
    var cart = window.Homedia && window.Homedia.cart && window.Homedia.cart.getState();
    if (!cart || !cart.items || variantId == null) return 0;
    var n = 0;
    cart.items.forEach(function (line) {
      if (String(line.variant_id) === String(variantId)) n += line.quantity || 0;
    });
    return n;
  }

  // Shopifys „Add-to-cart limit" (Admin → Einstellungen → Checkout → Erweiterte Einstellungen).
  // KEIN Plattform-Limit, sondern eine MERCHANT-EINSTELLUNG: Shops mit < 250 Verkäufen bekommen sie
  // seit 04/2025 automatisch auf 50 gesetzt. Sie ist im Storefront-Liquid NICHT auslesbar — deshalb
  // spiegeln wir sie im Theme-Setting `cart_add_limit`. Wer den Wert im Admin ändert, muss ihn dort
  // nachziehen. (help.shopify.com/en/manual/checkout-settings/add-to-cart-limit)
  //
  // Sie gilt PRO VARIANTE über den GESAMTEN Warenkorb — nicht pro Zeile. Dieselbe Variante kann in
  // mehreren Zeilen liegen (Add-ons bekommen eigene properties → eigene Zeile) und teilt sich das
  // Budget. Deshalb wird unten gegen qtyInCart() gerechnet, das über alle Zeilen summiert.
  //
  // Das hier ist nur die UI-Vorabprüfung. Die Garantie liefert cart.js:resync() — es baut die
  // Ansicht nach JEDER Mutation aus der Server-Antwort neu auf. Ändert jemand das Limit im Admin,
  // bleibt die Anzeige also trotzdem korrekt, auch wenn diese Zahl veraltet.
  var CART_LIMIT_FALLBACK = 50;

  function cartLimit() {
    var n = parseInt(window.theme && window.theme.cartAddLimit, 10);
    return !isNaN(n) && n > 0 ? n : CART_LIMIT_FALLBACK;
  }

  function variantHardMax(v) {
    var m = cartLimit();
    var rule = v && v.quantity_rule;
    var ruleMax = rule && parseInt(rule.max, 10);
    if (ruleMax && !isNaN(ruleMax) && ruleMax < m) m = ruleMax;
    return m;
  }

  // Wie viel darf von dieser Variante INSGESAMT im Warenkorb liegen? Das Kleinere aus Bestand und
  // Add-to-cart-Limit. Math.min(Infinity, 50) === 50 → der Deckel greift auch ohne Bestandsführung.
  function variantMaxInCart(v) {
    return Math.min(variantStock(v), variantHardMax(v));
  }

  // Bindet der BESTAND (dann ist „nur noch X verfügbar" die richtige Aussage) oder das
  // Bestell-Limit (dann wäre „nicht verfügbar" schlicht gelogen — die Ware liegt ja im Regal)?
  function stockIsBinding(v) {
    return variantStock(v) <= variantHardMax(v);
  }

  // Maximal noch hinzufügbare Menge. qtyInCart() summiert über ALLE Zeilen derselben Variante —
  // genau so rechnet auch der Server (das Limit ist variantenweit, nicht zeilenweit).
  function maxAddable() {
    return Math.max(0, variantMaxInCart(currentVariant) - qtyInCart(currentVariant && currentVariant.id));
  }

  // Limit auf die UI anwenden: max-Attribut, „+"-Button, Add-Button, Hinweistext.
  function applyStockLimit() {
    var max = maxAddable();               // immer endlich (der 50er-Deckel greift immer)
    var byStock = stockIsBinding(currentVariant);
    var cap = variantMaxInCart(currentVariant);

    if (qtyInput) {
      if (max > 0) qtyInput.setAttribute('max', max);
      else qtyInput.removeAttribute('max');
    }

    // „+" sperren, wenn das Limit erreicht ist (aria-disabled, nicht disabled → fokussierbar).
    var atMax = getQty() >= Math.max(1, max);
    root.querySelectorAll('[data-qty-inc]').forEach(function (b) {
      if (atMax) b.setAttribute('aria-disabled', 'true');
      else b.removeAttribute('aria-disabled');
    });

    // Nichts mehr hinzufügbar → Add-Button sperren.
    var nothingLeft = max === 0 && currentVariant && currentVariant.available;
    if (addBtn && currentVariant && currentVariant.available) addBtn.disabled = !!nothingLeft;

    // Hinweistext. Zwei Grenzen → zwei Aussagen. Bei erreichtem BESTELL-Limit darf dort NICHT
    // „nicht verfügbar" stehen — die Ware ist verfügbar, nur nicht in dieser Menge pro Bestellung.
    var hint = root.querySelector('[data-qty-limit]');
    if (hint) {
      var msg = '';
      var perOrder = function () {
        return (strings.qtyMaxPerOrder || 'Mehr als __count__ Stück pro Bestellung sind nicht möglich.')
          .replace('__count__', cap);
      };
      if (nothingLeft) {
        // Kaufbutton ist gesperrt — der Grund muss immer dastehen, unabhängig vom Schwellwert.
        msg = byStock
          ? (strings.qtyMaxInCart || 'Du hast bereits alle verfügbaren Stück im Warenkorb.')
          : perOrder();
      } else if (max > 0 && max < LOW_STOCK_HINT_BELOW) {
        msg = byStock
          ? (strings.qtyMax || 'Nur noch __count__ verfügbar').replace('__count__', max)
          : perOrder();
      }
      hint.textContent = msg;
      hint.hidden = msg === '';
    }

    // Pack-Pills (bundle.js) über das Limit informieren → Stufen darüber sperren.
    document.dispatchEvent(new CustomEvent('pdp:qtylimit', {
      detail: { max: max, variant: currentVariant }
    }));
  }

  // Aktualisiert die große Buy-Box-Preisanzeige (.hm-price aus price.liquid)
  function updateBuyPrice(v) {
    if (!priceEl) return;
    var nowEl = priceEl.querySelector('.hm-price__now');
    var uvpWrap = priceEl.querySelector('.hm-price__uvp');
    var uvpVal = priceEl.querySelector('.hm-price__uvp s');
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    if (nowEl) {
      // „ab"-Präfix entfällt auf der PDP (konkrete Variante)
      nowEl.textContent = money(v.price);
    }
    var priceBox = priceEl.querySelector('.hm-price');
    if (priceBox) priceBox.classList.toggle('is-sale', !!onSale);
    if (uvpWrap) uvpWrap.style.display = onSale ? '' : 'none';
    if (uvpVal && onSale) uvpVal.textContent = money(v.compare_at_price);
    updateShipLine(v);
    updateDiscountBadges(v);
  }

  // Rabatt-Badge(s) beim Variantenwechsel mitziehen — Buy-Box UND Galerie tragen [data-discount-badge]
  // (mit always:true als stabilen Knoten gerendert). Ohne gültigen Rabatt → [hidden]; sonst Prozent
  // + aria-label aus der %%PCT%%-Vorlage (identische Rechnung wie discount-badge.liquid).
  function updateDiscountBadges(v) {
    var badges = root.querySelectorAll('[data-discount-badge]');
    if (!badges.length) return;
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    var pct = onSale ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
    if (pct <= 0) onSale = false;
    badges.forEach(function (b) {
      if (onSale) {
        b.hidden = false;
        b.textContent = '−' + pct + ' %';
        var tpl = b.getAttribute('data-aria-tpl');
        if (tpl) b.setAttribute('aria-label', tpl.split('%%PCT%%').join(pct));
      } else {
        b.hidden = true;
      }
    });
  }

  // Versandhinweis nach Variantenpreis: ab Free-Ship-Schwelle „Kostenloser Versand",
  // sonst Standardpreis + „ab X € kostenlos". Schwelle steckt als data-Attribut (Cents) im DOM,
  // die fertigen Texte kommen aus window.theme.strings (Preis/Schwelle sind global, nicht variantenabhängig).
  function updateShipLine(v) {
    var line = root.querySelector('[data-buy-shipline]');
    if (!line) return;
    var slot = line.querySelector('[data-buy-ship]');
    if (!slot) return;
    var thr = parseInt(line.getAttribute('data-free-threshold'), 10);
    if (isNaN(thr)) return;
    if (v.price >= thr) {
      slot.innerHTML = ' · <strong class="hm-buy__freeship">' + (strings.shipFree || 'Kostenloser Versand') + '</strong>';
    } else {
      slot.innerHTML = ' · ' + (strings.shipFlat || '') +
        ' · <span class="hm-buy__freehint">' + (strings.shipFreeFrom || '') + '</span>';
    }
  }

  function refreshTotals() {
    var unit = currentVariant ? currentVariant.price : 0;
    var qty = getQty();
    var total = unit * qty;
    checkedAddons().forEach(function (a) { total += a.price; });
    if (addTotal) addTotal.textContent = money(total);
    if (stickyPrice) stickyPrice.textContent = money(unit * qty);
    // Mobile-Sticky zeigt dieselbe Gesamtsumme wie die Buy-Box (Variante × Menge + Extras).
    if (stickyTotal) stickyTotal.textContent = money(total);
    // Alle Mengen-Anzeigen (z. B. Sticky-Stepper) mit dem quantity-Input synchron halten.
    root.querySelectorAll('[data-qty-mirror]').forEach(function (m) { m.textContent = qty; });
  }

  // =========================================================================
  // SUBMIT — Hauptprodukt + Extras als items[]
  // =========================================================================
  if (form) {
    form.addEventListener('submit', function (e) {
      var addons = checkedAddons();
      if (!window.Homedia || !window.Homedia.cart) return; // PE: nativer POST
      e.preventDefault();
      // stopPropagation: cart.js hat einen DOKUMENT-weiten submit-Listener auf /cart/add —
      // ohne dies würde er zusätzlich addFromForm() auslösen (Doppel-Add). Wir bauen items[]
      // hier selbst (Hauptprodukt + Extras) und übergeben an denselben Controller.
      e.stopPropagation();
      // Re-Entry-Guard: laufender Add → Doppelklick ignorieren (erst NACH preventDefault,
      // sonst würde der native Form-POST /cart/add feuern = genau das Doppel-Add).
      if (addBtn && addBtn.getAttribute('aria-disabled') === 'true') return;
      if (!currentVariant || !currentVariant.available) return;

      if (addBtn) addBtn.setAttribute('aria-disabled', 'true');
      var qty = getQty();
      var items = [{
        id: currentVariant.id,
        quantity: qty,
        properties: {}
      }];
      var mainHandle = (data && data.handle) || '';
      addons.forEach(function (a) {
        items.push({
          id: parseInt(a.id, 10),
          quantity: 1,
          properties: mainHandle ? { _addon_for: mainHandle } : {}
        });
      });

      // cart.add feuert cart:added → Drawer öffnet im „Hinzugefügt"-Modus (nur dieses Produkt + Empfehlungen).
      // KEIN cart.open() danach (würde in den Voll-Listen-Modus zurücksetzen).
      window.Homedia.cart.add({ items: items })
        .catch(function () { })
        .then(function () { if (addBtn) addBtn.removeAttribute('aria-disabled'); });
    });
  }

  // =========================================================================
  // SOFORT KAUFEN — Hauptprodukt + Extras adden, dann DIREKT zum Checkout (kein Drawer)
  // =========================================================================
  if (buyBtn) {
    buyBtn.addEventListener('click', function () {
      if (buyBtn.getAttribute('aria-disabled') === 'true') return; // Re-Entry-Guard: laufender Add
      if (buyBtn.disabled) return;
      if (!currentVariant || !currentVariant.available) return;
      if (!window.Homedia || !window.Homedia.cart) return;
      buyBtn.setAttribute('aria-disabled', 'true');

      var items = [{ id: currentVariant.id, quantity: getQty(), properties: {} }];
      var mainHandle = (data && data.handle) || '';
      checkedAddons().forEach(function (a) {
        items.push({ id: parseInt(a.id, 10), quantity: 1, properties: mainHandle ? { _addon_for: mainHandle } : {} });
      });

      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var checkoutUrl = rootUrl.charAt(rootUrl.length - 1) === '/' ? rootUrl + 'checkout' : rootUrl + '/checkout';

      // Kanonischer Controller: silent → Drawer bleibt zu (cart-drawer.js ignoriert silente
      // cart:added-Events), announce:false → keine Erfolgs-Ansage (es geht direkt zum Checkout).
      // Fehler-Ansage übernimmt cart.js selbst (announce(err.message) mit echter Shopify-Meldung).
      window.Homedia.cart.add({ items: items }, { silent: true, announce: false })
        .then(function () { window.location.href = checkoutUrl; })
        .catch(function () { buyBtn.removeAttribute('aria-disabled'); });
    });

    // bfcache: Browser-Back vom Checkout restauriert das DOM samt aria-disabled —
    // Guard wieder lösen, sonst blockiert der Re-Entry-Guard den Button dauerhaft.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) buyBtn.removeAttribute('aria-disabled');
    });
  }

  // =========================================================================
  // GALERIE
  // =========================================================================
  function initGallery() {
    var gal = root.querySelector('[data-pdp-gallery]');
    if (!gal) return;
    var stage = gal.querySelector('[data-gallery-stage]');
    var slides = gal.querySelectorAll('[data-gallery-slide]');
    if (slides.length < 2) return;
    var thumbs = gal.querySelectorAll('[data-gallery-thumb]');
    var dots = gal.querySelectorAll('[data-gallery-dot]');

    // Vertikale Thumb-Navigation (Desktop): Track auf Bildhöhe begrenzen + abschnittsweises Blättern.
    var thumbWrap = gal.querySelector('[data-gallery-thumbwrap]');
    var thumbTrack = thumbWrap && thumbWrap.querySelector('[data-gallery-thumbtrack]');
    var thumbUp = thumbWrap && thumbWrap.querySelector('[data-gallery-thumb-up]');
    var thumbDown = thumbWrap && thumbWrap.querySelector('[data-gallery-thumb-down]');
    var stageWrap = gal.querySelector('.hm-gal__stage-wrap');
    var thumbRaf = null;

    function activate(index) {
      slides.forEach(function (s, i) {
        if (i === index) { s.removeAttribute('aria-hidden'); }
        else { s.setAttribute('aria-hidden', 'true'); }
      });
      thumbs.forEach(function (t, i) {
        var on = i === index;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      ensureThumbVisible(index);
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(i); });
    });

    // Für den Variantenwechsel: Galerie per Medien-ID umschalten.
    selectMedia = function (mediaId) {
      if (mediaId == null) return;
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) {
          if (stage && stage.scrollWidth > stage.clientWidth + 4) {
            // Mobile-Swipe-Rail: nur scrollen — alle Slides bleiben sichtbar, daher KEIN aria-hidden
            // setzen (sonst wären sichtbare, wischbare Bilder aus dem A11y-Baum verschwunden).
            stage.scrollTo({ left: i * stage.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
          } else {
            // Desktop-Stack: aktive Slide einblenden (aria-hidden auf den übrigen ist hier korrekt).
            activate(i);
          }
          return;
        }
      }
    };

    // Mobile: Swipe-Snap → aktiven Dot ableiten. NICHT über Math.round(scrollLeft/clientWidth):
    // bei scroll-snap-align:center bzw. geclamptem Max-Scroll (letzte Folie) ergibt das einen
    // Off-by-one (erste Folie ohne Dot, letzte Folie auf dem vorletzten Dot). Stattdessen die
    // Folie wählen, deren Mitte der sichtbaren Stage-Mitte am nächsten ist — robust gegen Layout.
    function activeSlideIndex() {
      var mid = stage.getBoundingClientRect().left + stage.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      slides.forEach(function (s, i) {
        var r = s.getBoundingClientRect();
        var dist = Math.abs((r.left + r.width / 2) - mid);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      return best;
    }
    if (stage) {
      var raf = null;
      stage.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var idx = activeSlideIndex();
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        });
      }, { passive: true });
    }

    // -------- Vertikale Thumb-Navigation (Desktop) --------
    // Schritt = Thumb-Höhe + Zeilen-Gap (aus dem DOM gemessen, robust gegen CSS-Änderungen).
    function thumbStep() {
      if (!thumbTrack) return 86;
      var f = thumbTrack.querySelector('[data-gallery-thumb]');
      if (!f) return 86;
      var cs = getComputedStyle(thumbTrack);
      var gap = parseFloat(cs.rowGap || cs.gap || '12') || 12;
      return f.getBoundingClientRect().height + gap;
    }
    // Aktiven Thumb in den sichtbaren Bereich des Tracks holen (z. B. nach Variantenwechsel).
    function ensureThumbVisible(index) {
      if (!thumbTrack || !thumbWrap || !thumbWrap.classList.contains('is-scrollable')) return;
      var el = thumbs[index];
      if (!el) return;
      var top = el.offsetTop;
      var bottom = top + el.offsetHeight;
      if (top < thumbTrack.scrollTop) {
        thumbTrack.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
      } else if (bottom > thumbTrack.scrollTop + thumbTrack.clientHeight) {
        thumbTrack.scrollTo({ top: bottom - thumbTrack.clientHeight, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }
    // Track-Höhe an das große Bild binden + Pfeile je nach Überlauf/Scrollposition ein-/ausblenden.
    function syncThumbNav() {
      if (!thumbTrack || !thumbWrap || !stageWrap) return;
      if (thumbTrack.offsetParent === null) { // mobil ausgeblendet (Wrapper display:none)
        thumbWrap.classList.remove('is-scrollable');
        if (thumbUp) thumbUp.hidden = true;
        if (thumbDown) thumbDown.hidden = true;
        return;
      }
      thumbTrack.style.maxHeight = stageWrap.clientHeight + 'px';
      var overflow = thumbTrack.scrollHeight > thumbTrack.clientHeight + 1;
      thumbWrap.classList.toggle('is-scrollable', overflow);
      if (!overflow) {
        if (thumbUp) thumbUp.hidden = true;
        if (thumbDown) thumbDown.hidden = true;
        return;
      }
      if (thumbUp) thumbUp.hidden = thumbTrack.scrollTop <= 1;
      if (thumbDown) thumbDown.hidden = (thumbTrack.scrollTop + thumbTrack.clientHeight) >= (thumbTrack.scrollHeight - 1);
    }
    // Abschnittsweise blättern: um die Anzahl der vollständig sichtbaren Thumbs scrollen.
    function pageThumbs(dir) {
      if (!thumbTrack) return;
      var step = thumbStep();
      var visible = Math.max(1, Math.floor(thumbTrack.clientHeight / step));
      thumbTrack.scrollBy({ top: dir * visible * step, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    if (thumbUp) thumbUp.addEventListener('click', function () { pageThumbs(-1); });
    if (thumbDown) thumbDown.addEventListener('click', function () { pageThumbs(1); });
    if (thumbTrack) {
      thumbTrack.addEventListener('scroll', function () {
        if (thumbRaf) return;
        thumbRaf = requestAnimationFrame(function () { thumbRaf = null; syncThumbNav(); });
      }, { passive: true });
    }
    window.addEventListener('resize', function () {
      if (thumbRaf) return;
      thumbRaf = requestAnimationFrame(function () { thumbRaf = null; syncThumbNav(); });
    }, { passive: true });
    if ('ResizeObserver' in window && stageWrap) {
      new ResizeObserver(function () { syncThumbNav(); }).observe(stageWrap);
    }
    syncThumbNav();
  }

  // =========================================================================
  // COMPAT-VERDIKT
  // =========================================================================
  function initCompat() {
    var sel = root.querySelector('[data-compat-selector]');
    if (!sel) return;
    var select = sel.querySelector('[data-compat-select]');
    var verdict = sel.querySelector('[data-compat-verdict]');
    var vText = sel.querySelector('[data-verdict-text]');
    var vIcon = sel.querySelector('[data-verdict-icon]');
    var vCta = sel.querySelector('[data-verdict-cta]');
    if (!select || !verdict) return;

    var sData = {};
    try {
      var sEl = sel.querySelector('[data-compat-strings]');
      if (sEl) sData = JSON.parse(sEl.textContent);
    } catch (e) { sData = {}; }

    var hubAddon = root.querySelector('[data-addon-input]');
    var hubSelect = sel.querySelector('[data-compat-hub]');
    var hubWrap = sel.querySelector('[data-compat-hub-wrap]');

    // Hubs UND empfohlener Hub aus dem globalen Compat-Finder-Datentopf (gleiche Quelle wie das
    // Popup und die Kompatibilitätsseite). recommendedHub speist Verdikt-Name + CTA-Ziel.
    var allHubs = [];
    var recHub = null;
    try {
      var dEl = document.getElementById('compat-finder-data');
      if (dEl) {
        var d = JSON.parse(dEl.textContent);
        if (d && Array.isArray(d.hubs)) allHubs = d.hubs;
        if (d && d.recommendedHub) recHub = d.recommendedHub;
      }
    } catch (e) {}

    // %%HUB%%-Platzhalter in den Verdikt-Texten durch den echten Produkttitel des empfohlenen Hubs
    // ersetzen; die CTA verlinkt auf dessen Produktseite. Fallback = Locale-Text (kein Setting gepflegt).
    var hubName = (recHub && recHub.title) || sData.hub_name_fallback || '';
    sData.hub_url = (recHub && recHub.url) || '';
    ['needs_hub', 'none', 'add_hub_label'].forEach(function (k) {
      if (typeof sData[k] === 'string') sData[k] = sData[k].split('%%HUB%%').join(hubName);
    });

    function showCta() {
      if (!vCta) return;
      vCta.hidden = false;
      vCta.textContent = sData.add_hub_label || '';
      if (sData.hub_url) {
        // Direkt auf die Produktseite des empfohlenen Hubs (aus recommended_hub_product) verlinken.
        vCta.href = sData.hub_url;
        vCta.onclick = null;
      } else if (hubAddon) {
        // Fallback ohne auflösbares Hub-Produkt: Hub als Setup-Extra ankreuzen.
        vCta.href = '#';
        vCta.onclick = function (e) { e.preventDefault(); hubAddon.checked = true; onAddonToggle(); };
      }
    }
    function setVerdict(kind, text, withCta) {
      verdict.hidden = false;
      verdict.setAttribute('data-verdict', kind);
      vText.textContent = text || '';
      if (vCta) { if (withCta) showCta(); else vCta.hidden = true; }
    }
    function hideHub() {
      if (hubWrap) hubWrap.hidden = true;
      if (hubSelect) hubSelect.value = '';
    }

    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var val = select.value;
      if (!val) { verdict.hidden = true; hideHub(); return; }

      var isController = opt.getAttribute('data-controller') === 'true';
      var infraHint = opt.getAttribute('data-infra-hint') || '';

      if (val === '__none__') {
        hideHub();
        setVerdict('none', sData.none, true);
        return;
      }

      // Stufe 2: Zentralen für dieses System? → zweites Dropdown befüllen + zeigen (wie im Popup).
      var hubs = allHubs.filter(function (h) { return h.sys === val; });
      if (hubs.length && hubSelect && hubWrap) {
        hubSelect.innerHTML = '';
        var ph = document.createElement('option');
        ph.value = '';
        ph.textContent = sData.hub_placeholder || '';
        hubSelect.appendChild(ph);
        hubs.forEach(function (h) {
          var o = document.createElement('option');
          o.value = h.key;
          o.setAttribute('data-thread', h.thread === true ? 'true' : 'false');
          o.textContent = h.model ? (h.name + ' · ' + h.model) : h.name;
          hubSelect.appendChild(o);
        });
        hubWrap.hidden = false;
        // Zwischenstand: bitte die konkrete Zentrale wählen (genaues Verdikt folgt bei Auswahl).
        setVerdict('compatible', sData.choose_hub || sData.compatible, false);
      } else {
        // Keine Zentralen hinterlegt → System-Ebene wie gehabt.
        hideHub();
        if (isController) setVerdict('compatible', sData.compatible, false);
        else setVerdict('needs_hub', infraHint || sData.needs_hub, true);
      }
    });

    if (hubSelect) {
      hubSelect.addEventListener('change', function () {
        var o = hubSelect.options[hubSelect.selectedIndex];
        if (!hubSelect.value) { setVerdict('compatible', sData.choose_hub, false); return; }
        var thread = o.getAttribute('data-thread') === 'true';
        if (thread) setVerdict('compatible', sData.compatible, false);
        else setVerdict('needs_hub', sData.needs_hub, true);
      });
    }
  }

  // =========================================================================
  // STICKY-BAR (Desktop: IntersectionObserver auf Buy-Box; Mobile: CSS permanent)
  // =========================================================================
  function initSticky() {
    var sticky = root.querySelector('[data-pdp-sticky]');
    var buyBox = root.querySelector('[data-pdp-buybox]');
    if (!sticky) return;

    // Sticky-Add ist ein echter <button type="submit" form="pdp-form"> → ohne JS postet er das
    // Produkt-Form. Mit JS fängt der Form-submit-Listener (oben) den Submit ab (AJAX-Add + Drawer);
    // ein separater Click-Handler würde doppelt submitten und entfällt daher bewusst.

    // Platz unten reservieren = Höhe der Leiste. So scrollt der Seiteninhalt (inkl. Footer)
    // ÜBER die durchgehend sichtbare, fixe Leiste — sie überlagert nichts mehr (Verhalten wie Mobile).
    function reserveSpace() {
      document.body.style.paddingBottom = sticky.offsetHeight + 'px';
    }
    reserveSpace();
    window.addEventListener('resize', reserveSpace, { passive: true });

    var isMobile = window.matchMedia('(max-width: 749px)');
    if (isMobile.matches) {
      sticky.setAttribute('aria-hidden', 'false');
      return; // Mobile permanent via CSS
    }

    if (!buyBox || !('IntersectionObserver' in window)) return;

    // Desktop: Leiste erscheint, sobald die Buy-Box nach oben rausgescrollt ist — und bleibt
    // dann DURCHGEHEND sichtbar (Footer wird via reserveSpace freigehalten).
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.setAttribute('data-visible', show ? 'true' : 'false');
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }, { threshold: 0 }).observe(buyBox);
  }

  // =========================================================================
  // RECOMMENDATIONS (Product-Recommendations-API)
  // =========================================================================
  function initReco() {
    var sec = root.querySelector('[data-pdp-related]');
    if (!sec) return;
    // Kuratierte Empfehlungen (FBT-Set/Zubehör aus recommended_products) vorhanden → Sektion ist
    // bereits vollständig; keine Auto-Reco laden (und NICHT ausblenden, s. hideRailIfEmpty).
    if (sec.querySelector('.hm-fbt')) return;
    if (sec.getAttribute('data-show-reco') !== 'true') return;
    var rail = sec.querySelector('[data-reco-rail]');
    if (!rail) return;
    var pid = sec.getAttribute('data-product-id');
    var limit = parseInt(sec.getAttribute('data-reco-limit'), 10) || 4;
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var intent = sec.querySelector('.hm-pdp__rail:not([data-reco-rail])') ? 'related' : 'complementary';
    var htmlUrl = rootUrl.replace(/\/$/, '') + '/recommendations/products?product_id=' + pid +
      '&limit=' + limit + '&intent=' + intent;

    fetch(htmlUrl, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // Shopify liefert eine product-recommendations-Hülle; wir übernehmen vorhandene Cards
        var cards = doc.querySelectorAll('[data-product-card]');
        if (!cards.length) { hideRailIfEmpty(sec, rail); return; }
        cards.forEach(function (card) {
          var li = document.createElement('li');
          li.appendChild(card);
          rail.appendChild(li);
        });
        rail.hidden = false;
      })
      .catch(function () { hideRailIfEmpty(sec, rail); });
  }

  function hideRailIfEmpty(sec, rail) {
    // Kuratierte Inhalte (FBT-Set/Zubehör ODER eine kuratierte Rail) → Sektion bleibt sichtbar.
    var curated = sec.querySelector('.hm-fbt, .hm-pdp__rail:not([data-reco-rail])');
    if (!curated && rail) {
      // Keine Daten überhaupt → Sektion ausblenden
      sec.hidden = true;
    }
  }

  // =========================================================================
  // TECHNIK/VERGLEICH-TABS (nur Mobile sichtbar; Desktop zeigt beide Panels via CSS)
  // Verhalten wie home-bestsellers-Tabs: aria-selected + [hidden]-Toggle + Pfeiltasten.
  // =========================================================================
  function initTechTabs() {
    var sec = root.querySelector('[data-pdp-tech]');
    if (!sec) return;
    var tablist = sec.querySelector('[data-tech-tablist]');
    var panels = sec.querySelectorAll('[data-tech-panel]');
    if (!tablist || panels.length < 2) return;
    var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[data-tech-tab]'));

    function activate(idx) {
      tabs.forEach(function (tab, i) {
        var on = i === idx;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (panel, i) {
        if (i === idx) { panel.removeAttribute('hidden'); }
        else { panel.setAttribute('hidden', ''); }
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(i); });
      tab.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : (e.key === 'ArrowLeft' ? -1 : 0);
        if (!dir) return;
        e.preventDefault();
        var next = (i + dir + tabs.length) % tabs.length;
        activate(next);
        tabs[next].focus();
      });
    });
  }

  // =========================================================================
  // EVENTS
  // =========================================================================
  function onAddonToggle() { toggleBuyNow(); refreshTotals(); }

  root.querySelectorAll('[data-option-input]').forEach(function (inp) {
    inp.addEventListener('change', onVariantChange);
  });
  root.querySelectorAll('[data-addon-input]').forEach(function (cb) {
    cb.addEventListener('change', onAddonToggle);
  });

  // Qty-Stepper — ALLE Stepper (Buy-Box + Sticky, mobil) steuern denselben quantity-Input.
  // Der Sticky-Stepper spiegelt den Wert über [data-qty-mirror] (refreshTotals synchronisiert).
  if (qtyInput) {
    var clamping = false;

    function setQty(n) {
      var max = maxAddable(); // Bestand UND 50er-Limit, immer endlich
      var val = Math.max(1, isNaN(n) ? 1 : n);
      // Untergrenze bleibt 1, auch wenn max = 0 ist — der Add-Button ist in dem Fall gesperrt
      // (applyStockLimit), ein Mengenfeld mit „0" wäre nur verwirrend.
      val = Math.min(val, Math.max(1, max));

      var corrected = String(qtyInput.value) !== String(val);
      qtyInput.value = val;
      refreshTotals();
      applyStockLimit();

      // Wurde nach unten korrigiert (z. B. 4er-Pack-Pill bei nur 3 Stück Bestand), müssen Module,
      // die auf 'change' lauschen (bundle.js: aktive Pack-Pill), den KORRIGIERTEN Wert sehen.
      // Der Guard verhindert die Endlosschleife über unseren eigenen change-Listener unten.
      if (corrected && !clamping) {
        clamping = true;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        clamping = false;
      }
    }

    root.querySelectorAll('[data-qty-dec]').forEach(function (b) {
      b.addEventListener('click', function () { setQty(getQty() - 1); });
    });
    root.querySelectorAll('[data-qty-inc]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.getAttribute('aria-disabled') === 'true') return;
        setQty(getQty() + 1);
      });
    });
    // Deckt auch direktes Tippen ins Zahlenfeld ab.
    qtyInput.addEventListener('change', function () { setQty(getQty()); });

    // Der Warenkorb zählt gegen den Bestand: nach jedem Add/Ändern neu bewerten.
    document.addEventListener('cart:updated', function () { setQty(getQty()); });

    // Initial (auch wenn cart.js seinen ersten GET /cart.js noch nicht durch hat — cart:updated
    // holt es dann nach).
    applyStockLimit();
  }

  // No-JS-Variantenfix: pdp-buy-box rendert die hidden Varianten-ID bei Multi-Variant-Produkten
  // OHNE name-Attribut (No-JS submittet stattdessen das <noscript><select name="id">). Mit aktivem
  // JS aktivieren wir die hidden-ID als Submit-Quelle, indem wir das name-Attribut nachsetzen.
  if (idInput && !idInput.getAttribute('name')) idInput.setAttribute('name', 'id');

  // ---------- Experten-Check via Crisp ----------
  // Buttons/Links mit [data-door-check] öffnen den Crisp-Chat und senden eine vorbereitete
  // Visitor-Nachricht. Die Nachricht kommt pro Produkt aus [data-check-msg]; fehlt sie, wird eine
  // generische (produktneutrale) Nachricht mit Produktname gebaut. Ohne Crisp greift der href-Fallback.
  function initDoorCheck() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-door-check]');
      if (!t) return;
      if (!window.$crisp) return; // kein Crisp → normaler Link (PE)
      e.preventDefault();
      var prod = t.getAttribute('data-product') || '';
      var custom = t.getAttribute('data-check-msg') || '';
      try {
        window.$crisp.push(['do', 'chat:show']);
        window.$crisp.push(['do', 'chat:open']);
        window.$crisp.push(['set', 'session:segments', [['produkt-check']]]);
        if (prod) window.$crisp.push(['set', 'session:data', [[['check_produkt', prod]]]]);
        // Texte aus locales via window.theme.strings (theme.liquid); deutsche Literale bleiben als ||-Fallback.
        var msg = custom || (prod
          ? (strings.checkMsgNamed || 'Hallo! Ich habe eine Frage zu „[[product]]" und würde gern kurz klären, ob es zu mir passt. Könnt ihr mir weiterhelfen?').replace('[[product]]', prod)
          : (strings.checkMsgGeneric || 'Hallo! Ich habe eine Frage zu diesem Produkt und würde gern kurz klären, ob es zu mir passt. Könnt ihr mir weiterhelfen?'));
        window.$crisp.push(['do', 'message:send', ['text', msg]]);
      } catch (err) {}
    });
  }

  initGallery();
  initCompat();
  initSticky();
  initReco();
  initTechTabs();
  initDoorCheck();
  toggleBuyNow();
  refreshTotals();
})();
